import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Privacy from "@/pages/Privacy";
import Install from "@/pages/Install";
import Studio from "@/pages/Studio";
import VideoStudio from "@/pages/VideoStudio";
import Projects from "@/pages/Projects";
import Catalog from "@/pages/Catalog";
import Sales from "@/pages/Sales";
import Admin from "@/pages/Admin";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors theme="dark" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/confidentialitate" element={<Privacy />} />
            <Route path="/instalare" element={<Install />} />
            <Route path="/studio" element={<ProtectedRoute><Studio /></ProtectedRoute>} />
            {/* Video temporarily hidden from users — page/backend kept for easy reactivation */}
            <Route path="/video" element={<Navigate to="/studio" replace />} />
            <Route path="/projects" element={<ProtectedRoute><Projects /></ProtectedRoute>} />
            <Route path="/catalog" element={<ProtectedRoute><Catalog /></ProtectedRoute>} />
            <Route path="/sales" element={<ProtectedRoute roles={["admin", "sales"]}><Sales /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
